import React, { Dispatch, FC, SetStateAction } from 'react';
import { BankAccount } from '../../../../interfaces';
import { Button, Modal } from '../../../components';
import { detectBankByName } from '../../../../scripts';
import { Link } from 'react-router-dom';
import { PATH } from 'data/30pay.path';

interface Props {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    iBans: Omit<BankAccount, 'cardNumber'>[];
    onSelect: (iBan: Omit<BankAccount, 'cardNumber'>) => void;
}

export const IBanSelectionModal: FC<Props> = ({ open, setOpen, iBans, onSelect }) => {
    return (
        <Modal open={open} setOpen={setOpen} title={'انتخاب شماره شبا'}>
            <ul>
                {iBans.length !== 0 ? (
                    iBans.map((iBan) => (
                        <li
                            onClick={() => onSelect(iBan)}
                            key={iBan.id}
                            className={
                                'h-12 hover:bg-background rounded-lg px-3 flex items-center justify-between clickable'
                            }
                        >
                            <div className={'flex items-center gap-4'}>
                                <img
                                    src={detectBankByName(iBan.bank?.name)?.bank_logo}
                                    alt={'Bank'}
                                    className={'w-6 h-6'}
                                />
                                <span className={'text-base font-bold text-darkPurple-100'}>
                                    {iBan.bank ? iBan.bank.name : 'نامشخص'}
                                </span>
                            </div>
                            <span className={'font-medium text-base text-darkPurple-100'}>{iBan.iBan}</span>
                        </li>
                    ))
                ) : (
                    <div className="flex flex-col gap-6 items-center justify-center pt-2">
                        <h6 className="text-base font-medium text-darkPurple-80">تا کنون شماره شبایی ثبت نشده است</h6>
                        <Link className="w-full" to={PATH.cards}>
                            <Button className="w-full" type="primary">
                                ثبت شماره شبا جدید
                            </Button>
                        </Link>
                    </div>
                )}
            </ul>
        </Modal>
    );
};
